import { render, staticRenderFns } from "./AcessoTributacao.vue?vue&type=template&id=69161eac&scoped=true"
import script from "./AcessoTributacao.vue?vue&type=script&lang=js"
export * from "./AcessoTributacao.vue?vue&type=script&lang=js"
import style0 from "./AcessoTributacao.vue?vue&type=style&index=0&id=69161eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69161eac",
  null
  
)

export default component.exports